import { useLanguage } from '../i18n';

const members = [
  {
    id: 'mariano',
    name: 'Mariano Paz',
    path: '/equipo/mariano-paz',
    role: { es: 'Diseñador de juegos, artista y animador', en: 'Game designer, artist and animator' },
    image: '/mariano.png',
    accent: 'border-purple-400/45'
  },
  {
    id: 'nacho',
    name: 'Ignacio Naval Esparrell',
    path: '/equipo/ignacio-naval-esparrell',
    role: { es: 'Game developer, programador y productor', en: 'Game developer, programmer and producer' },
    image: '/Portraits_Nacho.png',
    accent: 'border-pink-400/45'
  },
  {
    id: 'manu',
    name: 'Francisco Emanuel Diaz Ortiz',
    path: '/equipo/francisco-emanuel-diaz-ortiz',
    role: { es: 'Concept artist, ilustrador y diseñador de entornos y props', en: 'Concept artist, illustrator, and environment and props designer' },
    image: '/manu.png',
    accent: 'border-indigo-400/45'
  },
  {
    id: 'tomas',
    name: 'Tomás Heredia',
    path: '/equipo/tomas-heredia',
    role: { es: 'Game developer, programador y productor', en: 'Game developer, programmer and producer' },
    image: '/Portraits_Tomi.png',
    accent: 'border-pink-400/45'
  }
];

const Members = ({ onShowCV }) => {
  const { language, t } = useLanguage();
  return (
    <section id="members" className="section-shell min-h-screen flex items-center justify-center px-4 py-12 sm:py-16 lg:py-20">
      <div className="section-content max-w-6xl mx-auto w-full">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="section-title text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4">
            {t('teamTitle')}
          </h2>
          <p className="text-purple-200 max-w-2xl mx-auto text-sm sm:text-base">
            {t('teamIntro')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6 lg:gap-8 max-w-4xl mx-auto">
          {members.map((member) => (
            <a
              key={member.id}
              href={member.path}
              className="modern-panel rounded-xl p-6 sm:p-8 text-center group transition-all duration-300 transform hover:-translate-y-1"
              onClick={(event) => { event.preventDefault(); onShowCV(member.id, member.path); }}
            >
              <div className={`w-28 h-28 sm:w-32 sm:h-32 lg:w-36 lg:h-36 rounded-xl mx-auto mb-5 overflow-hidden border ${member.accent} bg-black/20 flex items-center justify-center shadow-xl shadow-black/20`}>
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.role[language]}`}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2 group-hover:text-purple-200 transition-colors">
                {member.name}
              </h3>
              <p className="text-purple-200 text-sm sm:text-base min-h-[3rem] max-w-xs mx-auto">{member.role[language]}</p>
              <p className="text-purple-300 text-xs mt-4 font-semibold">{t('viewCv')}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Members;
